<template>
  <div>
    <v-row>
      <v-col>
        <ListFilters />
      </v-col>
    </v-row>
    <v-row no-gutters align="center">
      <v-col>
        <ListToolbar
          :statistic="{
            value: getNumberOfActiveDevices,
          }"
          i18nLabel="device.list.active"
          :state="devicesListState"
          :statisticDataState="numberDevicesActiveState"
          :paginationStart="getNavigationConfiguration.start"
          :elementsPerPage="getNavigationConfiguration.devicesPerPage"
          :isLastPage="getNavigationConfiguration.isLastDevicePage"
          :numberOfElements="getTotalDevices"
          @page-navigation-handler="pageNavigationHandler"
          @go-to-page="navigateToPage"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { IDevicesListState, INavigation, store } from '@/store/modules/devices/types';
import ListToolbar from '@/components/common/ListToolbar/ListToolbar.vue';
import ListFilters from '@/components/common/Filters/ListFilters.vue';

@Component({
  components: {
    ListToolbar,
    ListFilters
  }
})
export default class DevicesListToolbar extends Vue {
  private get devicesListState(): { [key: string]: boolean } {
    return {
      fetched: this.getDevicesListState.fetched.devicesList,
      loading: this.getDevicesListState.loading.devicesList,
      error: this.getDevicesListState.error.devicesList
    };
  }

  private get numberDevicesActiveState(): { [key: string]: boolean } {
    return {
      fetched: this.getDevicesListState.fetched.numberOfActiveDevices,
      loading: this.getDevicesListState.loading.numberOfActiveDevices,
      error: this.getDevicesListState.error.numberOfActiveDevices
    };
  }

  @store.Getter
  private getDevicesListState!: IDevicesListState;

  @store.Getter
  private getNavigationConfiguration!: INavigation;

  @store.Getter
  private getNumberOfActiveDevices!: number;

  @store.Getter
  private getTotalDevices!: number;

  @store.Action
  private updateNavigation!: (payload: INavigation) => Promise<void>;

  @store.Action
  private devicesListNavigation!: (params: {
    direction: 'forward' | 'backward',
  }) => void;

  private pageNavigationHandler(
    direction: 'forward' | 'backward'
  ): void {
    this.devicesListNavigation({
      direction
    });
  }

  private navigateToPage(page: number) {
    const current = {
      ...this.getNavigationConfiguration,
      start: page * this.getNavigationConfiguration.devicesPerPage - this.getNavigationConfiguration.devicesPerPage
    };
    this.updateNavigation(current);
  }
}
</script>
<style lang="scss" scoped>
@import './styles/device-list-toolbar.scss';
</style>
